const getDefaultState = () => ({
  auth: {
    session: false,
    user: null,
    brands: null,
    products: null,
    suppliers: null,
    pubnub: null,
  },
  twenty: {
    urls: {
      login: process.env.TWENTY_LOGIN_PAGE,
      api: process.env.TWENTY_API_URL,
      home: process.env.TWENTY_FRONT_PAGE,
      docs: process.env.TWENTY_DOCS_PAGE,
    },
  },
  snackbar: {
    show: 0,
    text: undefined,
    color: 'black',
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/app/defaultState.js